import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  listVettingApplications,
  normalizeVettingApplicationsListResponse,
} from '../services/vettingApplications';
import { vettingApplicationQueryKeys } from './query-keys';

export const useVettingApplicationsQuery = (params = {}, options = {}) =>
  useQuery({
    queryKey: vettingApplicationQueryKeys.list(params),
    queryFn: async () => {
      const result = await listVettingApplications(params);
      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch vetting applications');
      }
      return normalizeVettingApplicationsListResponse(result.data, params);
    },
    placeholderData: keepPreviousData,
    ...options,
  });
